import { EntityActionState } from '../../../Common/EntityState/EntityActionState';

/** Igual que `Persons.Domain.Enums.JuridictionIdentifierTypeEnum` (se serializa como número). */
export enum JuridictionIdentifierTypeEnum {
    NotDefined = 0,
    International = 1,
    National = 2,
    Regional = 3,
    Organizational = 4
}

export interface IdentifierTypeViewModel extends EntityActionState {
    id: number;
    name?: string | null;
    description?: string | null;
    juridictionType: JuridictionIdentifierTypeEnum;
    /** "Persona física" (Persons.API spec 005: mapeado desde la entidad, mismo nombre que en alta / modificación). */
    isForNaturalPerson: boolean;
    /**
     * @deprecated Alias de `isForNaturalPerson` que Persons.API conserva por compatibilidad (antes de su spec 005
     * llegaba siempre `false`). Sólo se lee como respaldo en `isForNaturalPersonOf`.
     */
    isForLegalPerson?: boolean;
    isForJuridicalPerson: boolean;
    identifierMask?: string | null;
    validationRegex?: string | null;
    isActive: boolean;
    isDeleted: boolean;
}

export interface IdentifierTypeCreateCommand {
    name?: string | null;
    description?: string | null;
    juridictionType: JuridictionIdentifierTypeEnum;
    isForNaturalPerson: boolean;
    isForJuridicalPerson: boolean;
    identifierMask?: string | null;
    validationRegex?: string | null;
    isActive: boolean;
}

export interface IdentifierTypeUpdateCommand extends IdentifierTypeCreateCommand {
    id: number;
}

/** Cuerpo de `PATCH persons/identifierTypes/{id}/status` (Persons.API spec 005). */
export interface IdentifierTypeStatusCommand {
    isActive: boolean;
}

/** `data` del 409 de la baja: el tipo lo usan identificadores de personas vigentes (Persons.API spec 005). */
export interface IdentifierTypeInUseViewModel {
    identifierTypeId: number;
    identifiersCount: number;
}

/**
 * Error de los servicios de tipos de identificador: el `ErrorType` de siempre más lo que el `ErrorType` genérico
 * pierde. `ServerMessage` es el `message` de la envoltura `Response` (el genérico lo pisa en los 404); `Data` es
 * su `data` (409: el tipo existente o `IdentifierTypeInUseViewModel`); `RouteMissing` indica que el servidor no
 * conoce la ruta (404 sin envoltura o 405: Persons.API anterior a la spec 005).
 */
export interface IdentifierTypeApiError {
    ErrorCode: number;
    ErrorMessage: string;
    Errors: string[];
    ServerMessage?: string;
    Data?: unknown;
    RouteMissing?: boolean;
}
